import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({ baseURL: API });

export const eventInfo = {
  name: "Rach Fest",
  tagline: "The Long Forty",
  startDate: "2027-05-13",
  endDate: "2027-05-16",
  location: "Villa Taina · Cabarete · Dominican Republic",
  host: "Rachel Long",
  contactEmail: "rachel.b.long@gmail.com",
};
